import {
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog
} from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';
import React from 'react';
import UploadEntities from './UploadEntites';
  
  const EntityCreateModal = ({  isEntityCreateModalOpen, handleIsEntityCreateModalOpenToggle, selectDomains, selectCategories, domain , onDomainsUpdate, fetchDomains, enableGoToInventory,fetchItems,  getCatgs,toggleItemAdded}) => {
    return (
      <MDBModal staticBackdrop={true} closeOnEsc={false}
        animationDirection='right'
        open={isEntityCreateModalOpen}
        centered={true}
        className="modal-backdrop.show"
      >
         <MDBModalDialog centered={true} size="xl">
          <MDBModalContent>
            <MDBModalBody>
              <UploadEntities handleIsEntityCreateModalOpenToggle={handleIsEntityCreateModalOpenToggle} selectDomains={selectDomains} selectCategories={selectCategories} domain={domain}  onDomainsUpdate={onDomainsUpdate} 
              fetchDomains={fetchDomains} enableGoToInventory={enableGoToInventory} fetchItems={fetchItems}  getCatgs={getCatgs} toggleItemAdded={toggleItemAdded}/>
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
        
      </MDBModal>
    );
  };
  
  EntityCreateModal.propTypes = {
    
    handleIsEntityCreateModalOpenToggle: PropTypes.func,
    isEntityCreateModalOpen: PropTypes.bool,
    selectDomains: PropTypes.arrayOf(PropTypes.object),
    selectCategories: PropTypes.arrayOf(PropTypes.object),
    domain: PropTypes.object,
    onDomainsUpdate: PropTypes.func,
    fetchDomains: PropTypes.func,
    enableGoToInventory: PropTypes.bool,
    fetchItems: PropTypes.func,
    getCatgs: PropTypes.func,
    toggleItemAdded: PropTypes.func,
  };
  
  export default EntityCreateModal;
  